import React from "react";

import { Paper, Skeleton, Stack } from "@mui/material";
import { Total } from "../../../../Components/Total";
import { Box } from "@mui/system";

export const MainSkeleton: React.FC = () => {
  return (
    <>
      <Total text="" number={""} />
      <Stack sx={{ m: "20px" }} spacing={4}>
        <Paper sx={{ height: "120px", backgroundColor: "#D1D3D5" }}>
          <Stack direction="row">
            <Box
              sx={{
                width: "60%",
                height: "120px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Skeleton animation="wave" width={150} height={30} />
            </Box>
            <Box
              sx={{
                width: "40%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "space-around",
              }}
            >
              <Skeleton animation="wave" width={100} height={30} />
              <Skeleton animation="wave" width={100} height={70} />
            </Box>
          </Stack>
        </Paper>

        <Paper sx={{ height: "120px", backgroundColor: "#D1D3D5" }}>
          <Stack direction="row">
            <Box
              sx={{
                width: "60%",
                height: "120px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Skeleton animation="wave" width={150} height={30} />
            </Box>
            <Box
              sx={{
                width: "40%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "space-around",
              }}
            >
              <Skeleton animation="wave" width={100} height={30} />
              <Skeleton animation="wave" width={100} height={70} />
            </Box>
          </Stack>
        </Paper>
        <Paper sx={{ height: "120px", backgroundColor: "#D1D3D5" }}>
          <Stack direction="row">
            <Box
              sx={{
                width: "60%",
                height: "120px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Skeleton animation="wave" width={150} height={30} />
            </Box>
            <Box
              sx={{
                width: "40%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "space-around",
              }}
            >
              <Skeleton animation="wave" width={100} height={30} />
              <Skeleton animation="wave" width={100} height={70} />
            </Box>
          </Stack>
        </Paper>
      </Stack>
    </>
  );
};
